import { legal, brand } from "../content/site";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";

// EDIT: this policy uses template wording with bracketed placeholders.
// Have it reviewed against your final setup before launch.
const sections = [
  {
    h: "Who we are",
    p: `This website is operated by ${legal.company} (company number ${legal.companyNumber}), registered office ${legal.registeredOffice}. We are the data controller for personal data collected through this site. You can contact us at any time via ${legal.email}.`,
  },
  {
    h: "What we collect",
    p: "We collect the information you give us directly: your name, email address and message when you contact us, and your delivery and contact details when you place an order. We also store your shopping bag contents in your own browser's local storage so your bag persists between visits.",
  },
  {
    h: "How we use it",
    p: "We use your information to respond to enquiries, process and deliver orders, and meet our legal obligations. We do not sell your personal data, and we do not use it for marketing unless you have explicitly asked us to keep in touch.",
  },
  {
    h: "Lawful bases (UK GDPR)",
    p: "We process personal data under the UK GDPR on the bases of: performance of a contract (fulfilling your order), legitimate interest (responding to enquiries and running our website), and legal obligation (tax and accounting records).",
  },
  {
    h: "Sharing",
    p: "We share personal data only with the service providers needed to run the shop — for example payment processors and delivery couriers — and only to the extent necessary. A full list of processors will be published here before launch.",
  },
  {
    h: "Retention",
    p: "We keep enquiry records for up to 24 months and order records for as long as tax and accounting law requires, after which they are securely deleted.",
  },
  {
    h: "Your rights",
    p: `You have the right to access, correct, delete or restrict the processing of your personal data, and to object to processing or request portability. To exercise any of these rights, email ${legal.email}. You also have the right to complain to the Information Commissioner's Office (ICO) at ico.org.uk.`,
  },
  {
    h: "Cookies",
    p: "This site uses only essential storage — including your browser's local storage for the shopping bag — and does not set advertising or tracking cookies. If this changes, this policy will be updated before any new cookies are introduced.",
  },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHeader eyebrow="Legal" title="Privacy Policy" body={legal.updated} />
      <section className="mx-auto max-w-3xl space-y-12 px-4 py-16 sm:px-8 lg:px-16 lg:py-24">
        {sections.map((s, i) => (
          <Reveal key={s.h} delay={Math.min(i * 0.04, 0.2)}>
            <h2 className="font-serif text-2xl font-light text-stone-900">{s.h}</h2>
            <p className="mt-4 text-sm leading-relaxed text-stone-600">{s.p}</p>
          </Reveal>
        ))}
        <p className="border-t border-stone-900/10 pt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500">
          Questions about privacy: {brand.email}
        </p>
      </section>
    </div>
  );
}
